export const LOYALTY_LANDING_PAGE = 'societe'

/** Hash URLs that open Société benefit details modals on the landing page. */
export const LOYALTY_HOTEL_UPGRADE_HASH = '#hotel-upgrade'
export const LOYALTY_AIRPORT_TRANSFER_HASH = '#airport-transfers'
export const LOYALTY_ESIM_DETAILS_HASH = '#esim-details'
export const LOYALTY_ESIM_INFO_HASH = '#esim-info'
export const LOYALTY_TOUR_EXP_CREDIT_HASH = '#tour-optional-extras-credit'
export const LOYALTY_TRAVELSHOOT_CREDIT_HASH = '#travelshoot-voucher'
export const LOYALTY_DISCOUNTED_INSURANCE_HASH = '#discounted-insurance'
export const LOYALTY_EXCLUSIVE_SAVINGS_HASH = '#infinite-exclusive-savings'

export function getLoyaltyBenefitModalPath(hash: `#${string}`): string {
  return `/${LOYALTY_LANDING_PAGE}${hash}`
}

export const LOYALTY_CREDIT_CARD_PAGE = 'societe/credit-card'
export const LOYALTY_INFINITE_ONBOARDING_PAGE = 'societe/infinite/onboarding'
export const LOYALTY_INFINITE_REGISTER_INTEREST_PAGE = 'societe/infinite/register-interest'
export const LOYALTY_OFFERS_HUB_PAGE = 'societe/offers'
export const LOYALTY_TERMS_AND_CONDITIONS_PAGE = 'societe-terms-and-conditions'
export const TASTE_OF_GOLD_DETAILS_PAGE = 'societe/taste-of-gold/details'
export const ESIM_DETAILS_PAGE = 'societe/esim/details'
export const ESIM_INFO_PAGE = 'societe/esim/info'
export const TIER_PROGRESSION_DETAILS_PAGE = 'societe/tier-progression/:highestTier'
export const TIER_UPGRADE_CAMPAIGN_PAGE = 'societe/:campaignSlug'
export const LOUNGE_PASSES_PAGE = 'societe/benefits/lounge-passes'
export const LOYALTY_PURCHASE_POINTS_PAGE = 'societe/buy-points'
export const LOYALTY_REWARDS_PAGE = 'societe/rewards-seats-maldives'
export const LOYALTY_SPEND_POINTS_PAGE = 'societe/using-my-points'
